module.exports = __webpack_public_path__ + "static/media/markImg.70612714.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Wizard/images/markImg.svg
// module id = 887
// module chunks = 0